import { render, staticRenderFns } from "./contract-info2024.vue?vue&type=template&id=3d4a0aeb&scoped=true"
import script from "./contract-info2024.vue?vue&type=script&lang=js"
export * from "./contract-info2024.vue?vue&type=script&lang=js"
import style0 from "./contract-info2024.vue?vue&type=style&index=0&id=3d4a0aeb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4a0aeb",
  null
  
)

export default component.exports